<template>
  <div class="" v-show="isShow"  >
      <audio-video-preview :isStartPreview="isAudioVideo" v-on:close="close()" :datas="$store.state.fileInfo.currentFile"></audio-video-preview>
      <imgs-preview :isStartPreview="isImgs" v-on:close="close()" :datas="$store.state.fileInfo.currentFile"></imgs-preview>
  </div>
</template>
<script>
  import audioVedio from './preview_audio_vedio.vue'
  import imgPreview from './preview_img.vue'
  import * as Util from 'util'
  export default {
    props: {
      isStartPreview: {
        type: Boolean,
        required: true
      },
      datas: Object
    },
    data () {
      return {
        isShow: false,
        isAudioVideo: false,
        isImgs: false,
        isDocs: false
      }
    },
    watch: {
      isStartPreview: function (val, oldVal) {
        console.log('isStartPreview:' + val)
        var auth = Util.getCSSActionByCode(this.datas.access_mode).authCSS.split(':')
        console.log(auth)
        var canpreview = false
        for (var o in auth) {
          if (auth[o] === 'preview') {
            canpreview = true
          }
        }
        if (!canpreview) {
          this.$store.commit(`setStartPreview`, false)
          let params = {
            isShow: true,
            message: '没有预览权限',
            iconClass: 'icon-error'
          }
          this.$store.commit('setToast', params)
          return
        }
        if (Util.canPreview(this.datas.mime_type)) {
          if (val === true) {
            if (Util.isAudio(this.datas.mime_type) || Util.isVideo(this.datas.mime_type)) {
              this.isImgs = false
              this.isAudioVideo = true
              this.isDocs = false
            } else if (Util.isDocs(this.datas.mime_type) || Util.isPdf(this.datas.mime_type)) {
              this.isImgs = false
              this.isAudioVideo = false
              this.isDocs = true
              this.$store.commit(`setStartPreview`, false)
              this.$router.push({name: 'preview_doc', params: {neid: this.datas.neid, uid: Util.getUserId(), token: Util.getSessionId()}})
            } else {
              this.isImgs = true
              this.isAudioVideo = false
              this.isDocs = false
            }
          }
          this.isShow = val
        } else {
          this.$store.commit(`setStartPreview`, false)
        }
      }
    },
    computed: {

    },
    methods: {
      close () {
        this.isShow = false
        this.isImgs = false
        this.isAudioVideo = false
        console.log('children colse ....')
        this.$emit(`close`)
      }
    },
    components: {
      'audio-video-preview': audioVedio,
      'imgs-preview': imgPreview
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// preview.vue?ca458138